module.exports = __webpack_public_path__ + "static/media/qsr.92713dcf.jpg";